import { BaseLoansData } from "@/models/loans/loansData";
import { getCompositeKey } from "@/services/format/key";
import envSettings from "@/services/system/envSettings";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { delay, http, HttpResponse } from "msw";
import { SetupServer } from "msw/node";
import { getLoansSet } from "../sets/loansSet";
import { infrastructureHandlers } from "./infrastructureHandlers";

const loansAdapter = createEntityAdapter({
  selectId: (item: BaseLoansData) =>
    getCompositeKey({
      a: "loansData",
      b: item.loansData,
    }).toString(),
});
let loansState = loansAdapter.getInitialState();
loansState = loansAdapter.setOne(loansState, getLoansSet);

const url = `${envSettings.FILTER_API_URL}/${envSettings.GET_LOANS_PREF}`;

export const loansHandlers = [
  http.get(url, async () => {
    await delay(150);
    return HttpResponse.json(Object.values(loansState.entities)[0], { status: 200 });
  }),
];

export const errorStatusLoansHandler = http.get(url, () => {
  return HttpResponse.json({ message: "Internal server error" }, { status: 500 });
});

export const faultyLoansHandler = http.get(url, () => {
  return HttpResponse.json({ weirdDataType: "Something went wrong" }, { status: 200 });
});

export const noDataLoansHandler = http.get(url, () => {
  return HttpResponse.json({ code: 6, reason: "No data" }, { status: 400 });
});

export const setupLoansHandler = (server: SetupServer) => {
  server.use(...loansHandlers, ...infrastructureHandlers);
};

export const setupErrorStatusLoansHandler = (server: SetupServer) => {
  server.use(errorStatusLoansHandler);
};

export const setupFaultyLoansHandler = (server: SetupServer) => {
  server.use(faultyLoansHandler);
};

export const setupNoDataLoansHandler = (server: SetupServer) => {
  server.use(noDataLoansHandler, ...infrastructureHandlers);
};
